



























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import BracketTeam from './components/BracketTeam.vue'
import {
  BracketAdjacencyMatrixEntity,
  BracketMatchAdjacencyMatrixEntity,
  BracketScoreResult,
  TournamentTeamListItemEntity
} from '@/api/stage'
import { dragscroll } from 'vue-dragscroll'

interface RoundRobinTeam {
  tournamentTeamId: string
  name: string
  win: number
  draw: number
  lose: number
}

interface RoundRobinMatchRound {
  round: number
  matches: BracketMatchAdjacencyMatrixEntity[]
}

@Component({
  components: {
    BracketTeam
  },
  directives: {
    dragscroll
  }
})
export default class RoundRobinSchedule extends Vue {
  @Prop({ type: Object, required: true })
  readonly bracket!: BracketAdjacencyMatrixEntity

  @Prop({ type: Number, default: 2 }) opponentNum!: number

  @Prop({ type: Boolean, default: false })
  readonly disableDragScroll!: boolean

  hoverTarget: string | null = null

  hoverTeam(teamId: string | null = null) {
    this.hoverTarget = typeof teamId === 'string' ? teamId : null
  }

  headers = [
    {
      text: 'Team',
      value: 'name'
    },
    {
      text: 'Win',
      value: 'win'
    },
    {
      text: 'Draw',
      value: 'draw'
    },
    {
      text: 'Lose',
      value: 'lose'
    }
  ]

  created() {
    // generate identifier if necessary
    if (
      this.rounds &&
      this.rounds
        .flatMap(r => r.matches)
        .filter(m => !!m.identifier && !m.isAdditional).length <= 0
    ) {
      let num = 1

      for (const round of this.rounds) {
        for (const match of (round as any).matches.filter(
          (m: any) => !m.isAdditional
        )) {
          match.identifier = `G${this.bracket.groupNumber}-M${num}`
          num++
        }
      }

      num = 1
      for (const round of this.rounds) {
        for (const match of (round as any).filter(
          (m: any) => m.matches.isAdditional
        )) {
          match.identifier = `AM-${num}`
          num++
        }
      }
    }
  }

  get teams() {
    const matchTeams = this.bracket.matches.flatMap(match => {
      return match.teams.map(team => ({
        tournamentTeamId: team.tournamentTeamId,
        name: team.name,
        score: match.scores.find(
          score => score.tournamentTeamId === team.tournamentTeamId
        )
      }))
    })

    // group teams
    const teams: RoundRobinTeam[] = []

    for (const matchTeam of matchTeams) {
      let team = teams.find(
        team => team.tournamentTeamId === matchTeam.tournamentTeamId
      )

      if (!team) {
        team = {
          tournamentTeamId: matchTeam.tournamentTeamId,
          name: matchTeam.name,
          win: 0,
          draw: 0,
          lose: 0
        }
        teams.push(team)
      }

      team!.win +=
        !matchTeam.score || matchTeam.score.result !== BracketScoreResult.Win
          ? 0
          : 1

      team!.draw +=
        !matchTeam.score || matchTeam.score.result !== BracketScoreResult.Draw
          ? 0
          : 1

      team!.lose +=
        matchTeam.score &&
        matchTeam.score.result !== BracketScoreResult.Win &&
        matchTeam.score.result !== BracketScoreResult.Draw
          ? 1
          : 0
    }

    return teams
  }

  get rounds() {
    let matches = this.bracket.matches
      .filter(
        (match, matchIndex) =>
          !this.bracket.edges.find(edge => edge[1] === matchIndex)
      )
      .sort((a, b) => a.bracketMatchId.localeCompare(b.bracketMatchId))

    let round = 1
    const rounds: RoundRobinMatchRound[] = []

    // WORKAROUND: we will never ever ever reach 100 rounds. for safety, just stop when reaching 100
    while (matches.length > 0 && round < 100) {
      rounds.push({
        round,
        matches
      })

      // find next round matches
      const nextMatches: BracketMatchAdjacencyMatrixEntity[] = []

      for (const match of matches) {
        const edges = this.bracket.edges.filter(
          edge => edge[0] === this.bracket.matches.indexOf(match)
        )

        for (const edge of edges) {
          const theMatch = this.bracket.matches[edge[1]]

          if (!nextMatches.find(match => match === theMatch)) {
            nextMatches.push(theMatch)
          }
        }
      }

      matches = nextMatches.sort((a, b) =>
        a.bracketMatchId.localeCompare(b.bracketMatchId)
      )
      round++
    }
    // Handle additional matches
    if (this.bracket.additionalMatches.length) {
      rounds.push({
        round: 0,
        matches: this.bracket.additionalMatches
      })
    }
    return rounds
  }

  getTeamScore(
    match: BracketMatchAdjacencyMatrixEntity,
    tournamentTeamId: string
  ) {
    return match.scores.find(
      score => score.tournamentTeamId === tournamentTeamId
    )!
  }

  getTeamTotalScore(
    match: BracketMatchAdjacencyMatrixEntity,
    team: TournamentTeamListItemEntity
  ) {
    // const useWinCount =
    //  match.scores.map(score => score.winCount).reduce((a, b) => a + b, 0) > 1
    const score = this.getTeamScore(match, team.tournamentTeamId)
    if (!score) return 0
    return score.totalScore
  }

  getTeamMatchBracketScoreResult(
    match: BracketMatchAdjacencyMatrixEntity,
    team: TournamentTeamListItemEntity
  ) {
    const matchIndex = this.bracket.matches.indexOf(match)

    if (
      matchIndex !== -1 &&
      match.teams.length === 1 &&
      !this.bracket.edges.find(edge => edge[1] === matchIndex)
    ) {
      return BracketScoreResult.Win
    }

    const score = this.getTeamScore(match, team.tournamentTeamId)
    if (!score) return BracketScoreResult.None
    return score.result
  }
}
